import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/services/users/authentication.service';
@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.authenticationService.getCurrentToken().then((token) => {
      if (token && token.length > 1) {
        return true;
      } else {
        if (
          state.url === '/' ||
          state.url === '' ||
          state.url === '/dashboard'
        ) {
          this.router.navigate(['/login']);
        } else {
          this.router.navigate(['/login'], {
            queryParams: { return: state.url },
          });
        }
        return false;
      }
    });
  }
}
